import { component as defineComponent } from 'flightjs';
import { debounce } from 'lodash';

export default defineComponent(function () {
    this.attributes({
        input: '[data-filter-text-input]',
        filterNameAttr: 'data-text-value-filter',
    });

    this.after('initialize', function () {
        var triggerFilterChangeFunc = debounce(this.triggerFilterChange.bind(this), 400);

        this.on('keyup', {
            input: triggerFilterChangeFunc,
        });

        //IE 10 clear input button
        this.on('input', {
            input: triggerFilterChangeFunc,
        });

        this.on(document, 'uiBrowseFiltersUpdated', this.updateDisplay);
    });

    this.triggerFilterChange = function () {
        var fieldName = this.$node.attr(this.attr.filterNameAttr);
        var fieldValue = this.select('input').val();
        var payload = {};

        if (this.select('input').data('filterValue') !== fieldValue) {
            this.select('input').data('filterValue', fieldValue);
            payload[fieldName] = fieldValue;
            this.trigger('uiBrowseFiltersUpdated', payload);
        }
    };

    this.updateDisplay = function (e, data) {
        var field = this.$node.attr(this.attr.filterNameAttr);

        if (data.hasOwnProperty(field)) {
            var newValue = data[field];
            this.select('input').data('filterValue', newValue);
            this.select('input').val(newValue);
        }
    };
});



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/text-value-filter.js